import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";
import { graphql } from "gatsby";
import React from "react";

import {
  BlogArticleLink,
  BlogArticlesContainer,
  Container,
  Content,
  HeadlineContainer,
  Illustration,
  Link,
  TagContainer,
  TagContent,
  VideoContainer,
  YoutubeIframe,
  YoutubeIframeContainer,
} from "./MordorBlogArticlesBlock.styles";

export interface MordorBlogArticlesBlockProps
  extends Queries.SanityMordorBlogArticlesBlock {}

const MordorBlogArticlesBlock: React.FC<MordorBlogArticlesBlockProps> = ({
  headline,
  _rawDescription,
  tagText,
  button,
  mordorBlogArticleItems,
  videoURL,
  videoAlt,
}) => (
  <Container>
    <Content>
      <HeadlineContainer>
        <TagContainer>
          <TagContent>
            <Text variant="L4" weight="medium">
              {tagText}
            </Text>
          </TagContent>
        </TagContainer>
        <Text variant="H3" as="h3" weight="medium">
          {headline}
        </Text>

        <RichText text={_rawDescription} variant="B2" />

        {button?.url && button?.label && (
          <Link href={button.url}>
            <Button
              variant={button.variant as ButtonVariant}
              label={button.label}
            />
          </Link>
        )}
      </HeadlineContainer>

      <BlogArticlesContainer>
        {mordorBlogArticleItems?.map((blogArticleItem) => {
          if (!blogArticleItem) return null;

          return (
            <BlogArticleLink
              key={blogArticleItem?.imageAlt}
              href={blogArticleItem?.url || undefined}
            >
              <Illustration>
                {blogArticleItem?.image && (
                  <OptimizedImage
                    imageFit="fill"
                    image={blogArticleItem.image}
                    alt={blogArticleItem.imageAlt}
                  />
                )}
              </Illustration>
            </BlogArticleLink>
          );
        })}
      </BlogArticlesContainer>

      {videoURL && videoAlt && (
        <VideoContainer>
          <YoutubeIframeContainer>
            <YoutubeIframe
              src={videoURL}
              title={videoAlt}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              $allowfullscreen
            />
          </YoutubeIframeContainer>
        </VideoContainer>
      )}
    </Content>
  </Container>
);

export const query = graphql`
  fragment MordorBlogArticlesBlock on SanityMordorBlogArticlesBlock {
    _key
    _type
    headline
    _rawDescription(resolveReferences: { maxDepth: 5 })
    tagText
    button {
      variant
      label
      url
    }
    mordorBlogArticleItems {
      image { ...OptimizedImage }
      imageAlt
      url
    }
    videoURL
    videoAlt
  }
`;

export default MordorBlogArticlesBlock;
